// extracted by mini-css-extract-plugin
export var blue = "_2d-h";
export var brand = "_2d-d";
export var darkGrey = "_2d-g";
export var disabled = "_2d-6";
export var disabledSubtle = "_2d-7";
export var error = "_2d-8";
export var green = "_2d-i";
export var grey = "_2d-f";
export var icon = "_2d-0";
export var inherit = "_2d-c";
export var lightGrey = "_2d-e";
export var orange = "_2d-k";
export var pink = "_2d-m";
export var primary = "_2d-1";
export var purple = "_2d-n";
export var quaternary = "_2d-4";
export var quinary = "_2d-5";
export var red = "_2d-l";
export var secondary = "_2d-2";
export var success = "_2d-b";
export var tertiary = "_2d-3";
export var warning = "_2d-9";
export var warningSecondary = "_2d-a";
export var white = "_2d-o";
export var yellow = "_2d-j";